import { TypographyProps } from '@design-system/typography';

import TMPLinkWrap from '~/components/TMPLinkWrap';
import { optionalLinkMapper } from '~/mappers/link';

import { Typography } from './models';

export const typographyMapper = ({
  content,
  tag,
  variant,
  link,
  align,
  size,
  weight,
  wrapping,
  className,
}: Typography) => {
  const linkProps = optionalLinkMapper(link);

  return {
    content,
    tag,
    variant,
    ...(linkProps
      ? { link: { component: TMPLinkWrap, props: linkProps } }
      : undefined),
    align,
    wrapping,
    size,
    weight,
    className,
  } as TypographyProps;
};
